import { Component, inject, OnDestroy } from '@angular/core';
import { NotifyService } from '@services/notify.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { INebulaNotification } from '@interfaces/nebula';
import { Clipboard } from '@angular/cdk/clipboard';
import { Subject } from 'rxjs';
import { SafeHtmlPipe } from '@pipes/safe-html.pipe';

@Component({
  selector: 'app-global-notification',
  templateUrl: './global-notification.component.html',
  styleUrls: ['./global-notification.component.scss'],
  imports: [SafeHtmlPipe]
})
export class GlobalNotificationComponent implements OnDestroy {
  private router = inject(Router);
  private clipboard = inject(Clipboard);

  isShowDetails: boolean[] = [];
  notifications: INebulaNotification[] = [];
  jsonErrors = { errors: [] as INebulaNotification[] };

  #destroyable$ = new Subject<void>();

  constructor() {
    /**
     * Notification: automatisch ausblenden: when the route changed
     */
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.#destroyable$)
      )
      .subscribe({
        next: () => {
          this.closeGlobalNotifications();
        }
      });

    NotifyService.getGlobalNotifications()
      .pipe(takeUntil(this.#destroyable$))
      .subscribe({
        next: notifications => {
          this.notifications = notifications;
        }
      });
  }

  ngOnDestroy(): void {
    this.#destroyable$.next();
    this.#destroyable$.complete();
  }

  /**
   * copy error in clipboard
   */
  copyError(): void {
    this.notifications.forEach(error => {
      const errorDetails = {
        class: error.class,
        message: error.message,
        details: error.details
          .replace(/<\/?[^>]+>/gi, '')
          .replace(/(\r\n|\n|\r)/gi, '')
          .replace(/\s\s+/g, ' ')
      };
      this.jsonErrors.errors.push(errorDetails);
    });
    this.clipboard.copy(JSON.stringify(this.jsonErrors));
    NotifyService.global.success('Anwendungsfehler wurde in die Zwischenablage kopiert.');
  }

  /**
   * empty the notifier
   */
  closeGlobalNotifications(): void {
    this.isShowDetails = [];
    NotifyService.destroyNotifications();
  }
}
